var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMonacoIconErrorSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 20,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5233333,0 20,4.47666667 20,10 C20,15.5233333 15.5233333,20 10,20 C4.47666667,20 0,15.5233333 0,10 C0,4.47666667 4.47666667,0 10,0 Z",
    fill: "#D13B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.922589,6.07741102 C14.2229923,6.37781432 14.2461002,6.85050686 13.9919128,7.1774162 L13.922589,7.25592232 L11.1783333,9.99933333 L13.922589,12.7440777 C14.2480259,13.0695146 14.2480259,13.5971521 13.922589,13.922589 C13.6221857,14.2229923 13.1494931,14.2461002 12.8225838,13.9919128 L12.7440777,13.922589 L9.99933333,11.1783333 L7.25592232,13.922589 C6.93048541,14.2480259 6.40284793,14.2480259 6.07741102,13.922589 C5.77700771,13.6221857 5.75389977,13.1494931 6.00808718,12.8225838 L6.07741102,12.7440777 L8.82133333,9.99933333 L6.07741102,7.25592232 C5.75197411,6.93048541 5.75197411,6.40284793 6.07741102,6.07741102 C6.37781432,5.77700771 6.85050686,5.75389977 7.1774162,6.00808718 L7.25592232,6.07741102 L9.99933333,8.82133333 L12.7440777,6.07741102 C13.0695146,5.75197411 13.5971521,5.75197411 13.922589,6.07741102 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 20,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5233333,0 20,4.47666667 20,10 C20,15.5233333 15.5233333,20 10,20 C4.47666667,20 0,15.5233333 0,10 C0,4.47666667 4.47666667,0 10,0 Z",
    fill: "#D13B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.922589,6.07741102 C14.2229923,6.37781432 14.2461002,6.85050686 13.9919128,7.1774162 L13.922589,7.25592232 L11.1783333,9.99933333 L13.922589,12.7440777 C14.2480259,13.0695146 14.2480259,13.5971521 13.922589,13.922589 C13.6221857,14.2229923 13.1494931,14.2461002 12.8225838,13.9919128 L12.7440777,13.922589 L9.99933333,11.1783333 L7.25592232,13.922589 C6.93048541,14.2480259 6.40284793,14.2480259 6.07741102,13.922589 C5.77700771,13.6221857 5.75389977,13.1494931 6.00808718,12.8225838 L6.07741102,12.7440777 L8.82133333,9.99933333 L6.07741102,7.25592232 C5.75197411,6.93048541 5.75197411,6.40284793 6.07741102,6.07741102 C6.37781432,5.77700771 6.85050686,5.75389977 7.1774162,6.00808718 L7.25592232,6.07741102 L9.99933333,8.82133333 L12.7440777,6.07741102 C13.0695146,5.75197411 13.5971521,5.75197411 13.922589,6.07741102 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
});
export default SvgMonacoIconErrorSolid;
export const raw = __webpack_public_path__ + "static/media/monaco-icon-error-solid.588154fc132f20486bba4e100f6222a8.svg";